import { getBorderThreshold } from './get-border-threshold.js';
import { markersReducer } from './utils.js';
import { ChartGrid } from '../../../core/components/chart-grid/ChartGridRoot.js';
import { useGridPlotSize } from '../../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { ThresholdBar } from '../../../core/components/threshold-bar/ThresholdBar.js';
import { useAxesFormatter } from '../../hooks/useAxesFormatter.js';
import { useGetThresholds } from '../../hooks/useGetThresholds.js';
import { useVisibleAxesConfig } from '../../hooks/useVisibleAxesConfig.js';
import { useXYChartData } from '../../hooks/useXYChartData.js';
import { useXYChartScales } from '../../hooks/useXYChartScales.js';
import { useSetState } from '../../store/selectors.js';
import { AREAS } from '../../utils/grid-templates.js';

export const XYChartThresholdArea = () => {
  const { thresholds, none } = useGetThresholds();
  const { left, right } = useVisibleAxesConfig();
  const axesIdToScales = useXYChartScales();
  const axesIdToFormatter = useAxesFormatter();
  const { width } = useGridPlotSize();
  const { left: leftConfig, right: rightConfig } = useVisibleAxesConfig();
  const setState = useSetState();
  const { axes } = useXYChartData();

  if (none) {
    return null;
  }

  const leftMarkers = thresholds.reduce(
    markersReducer({
      axis: 'left',
      axisConfig: leftConfig,
      axesIdToScales,
      axesIdToFormatter,
      width,
      axes,
    }),
    [],
  );

  const rightMarkers = thresholds.reduce(
    markersReducer({
      axis: 'right',
      axisConfig: rightConfig,
      axesIdToScales,
      axesIdToFormatter,
      width,
      axes,
    }),
    [],
  );

  const handleHover = (id: string | undefined) => {
    setState((prev) => ({
      ...prev,
      thresholds: {
        ...prev.thresholds,
        hoveredThresholdId: id,
      },
    }));
  };

  const { leftBorder, rightBorder } = getBorderThreshold(left, right);

  return (
    <>
      {leftMarkers.length ? (
        <ChartGrid.GridArea
          gridArea={AREAS.leftThreshold}
          key="leftThreshold"
          data-testid="left-threshold-area"
        >
          {(args) => {
            return (
              <ThresholdBar
                borderArea={leftBorder}
                markers={leftMarkers}
                length={args.availableHeight}
                layout="vertical"
                onHover={handleHover}
              />
            );
          }}
        </ChartGrid.GridArea>
      ) : null}
      {rightMarkers.length ? (
        <ChartGrid.GridArea
          gridArea={AREAS.rightThreshold}
          key="rightThreshold"
          data-testid="right-threshold-area"
        >
          {(args) => {
            return (
              <ThresholdBar
                borderArea={rightBorder}
                markers={rightMarkers}
                length={args.availableHeight}
                layout="vertical"
                onHover={handleHover}
              />
            );
          }}
        </ChartGrid.GridArea>
      ) : null}
    </>
  );
};

XYChartThresholdArea['displayName'] = 'XYChartThresholdArea';
